const editRequestDialog = {
  title: "Edit Data Request",
  fields: {
    title: "Title *",
    description: "Description *",
    requestedFields: "Requested Fields *",
  },
  errors: {
    noFields: "Please specify at least one requested field",
    updateFailed: "Failed to update request",
  },
  actions: {
    cancel: "Cancel",
    saving: "Saving...",
    saveChanges: "Save Changes",
  },
};

export default editRequestDialog;
